
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.3","stroke":"#7B01B5","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M7.447 6.747h1.232V11.4H7.447V6.747zm-.055-1.66c0-.191.073-.349.22-.474a.773.773 0 01.495-.187.69.69 0 01.473.187c.146.125.22.283.22.473 0 .191-.074.349-.22.473a.715.715 0 01-.473.176.773.773 0 01-.495-.187.583.583 0 01-.22-.462z","fill":"#7B01B5"}})])
          )
        }
      }
    